"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NeedMoreInfoComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var NeedMoreInfoComponent = function NeedMoreInfoComponent(_ref) {
  var onNeedMoreInfo = _ref.onNeedMoreInfo;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 6,
    pt: 3,
    pb: 3
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "secondary",
    onClick: onNeedMoreInfo
  }, "Need more info"));
};

exports.NeedMoreInfoComponent = NeedMoreInfoComponent;
NeedMoreInfoComponent.propTypes = {
  onNeedMoreInfo: _propTypes.default.func.isRequired
};
var _default = NeedMoreInfoComponent;
exports.default = _default;